<template>
  <ol-map
    :loadTilesWhileAnimating="true"
    :loadTilesWhileInteracting="true"
    style="height: 400px"
  >
    <ol-view
      ref="view"
      :center="center"
      :rotation="rotation"
      :zoom="zoom"
      :projection="projection"
    />
    <ol-tile-layer>
      <ol-source-osm />
    </ol-tile-layer>

    <ol-vector-layer>
      <ol-source-vector>
        <ol-feature>
          <ol-geom-point :coordinates="coordinate"></ol-geom-point>
          <ol-style>
            <ol-style-icon :src="hereIcon" :scale="1.0"></ol-style-icon>
          </ol-style>
        </ol-feature>
      </ol-source-vector>
    </ol-vector-layer>
  </ol-map>
</template>

<script>
import hereIcon from "@/assets/here.svg";
import { ref } from "vue";
export default {
  props: ["long", "lat"],
  setup(props) {
    const center = ref([props.long, props.lat]);
    const projection = ref("EPSG:4326");
    const zoom = ref(18);
    const rotation = ref(0);
    const coordinate = ref([props.long, props.lat]);

    return {
      center,
      projection,
      zoom,
      rotation,
      coordinate,
      hereIcon,
    };
  },
};
</script>
